import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {useSelector} from 'react-redux';
import {ROUTE_OPTIONS} from 'Utils/constants';
import {minutesToHours} from 'Utils/utils';

const RouteOption = ({
    type,
    selectRouteOption,
    selectedRouteOption,
    travelTimeMins,
    Icon,
    isNightSafeActive,
    primaryColors,
}) => {
    const {pathFound, isSearchingRoute} = useSelector(state => state.pageState.explorerMap);
    const showTravelTime = type === selectedRouteOption && pathFound && !isSearchingRoute;
    const isDisabled =
        selectedRouteOption === type && !(isSearchingRoute || (pathFound && !isSearchingRoute));
    const isSelected = selectedRouteOption === type && !isDisabled;

    return (
        <li
            className={classnames({
                selected: isSelected,
                isDisabled,
            })}
            style={
                isSelected
                    ? {color: primaryColors.text, backgroundColor: primaryColors.background}
                    : {}
            }
        >
            <Icon
                aria-label={type}
                color={isDisabled ? 'disabled' : undefined}
                onClick={() => {
                    if (type !== ROUTE_OPTIONS.DRIVE) {
                        selectRouteOption(type, isNightSafeActive);
                    } else {
                        selectRouteOption(type, false);
                    }
                }}
            />
            {showTravelTime && (
                <div className="travel-time">
                    {travelTimeMins >= 0 ? minutesToHours(travelTimeMins) : '...'}
                </div>
            )}
            {type === selectedRouteOption &&
                isSearchingRoute && <div className="travel-time">...</div>}
        </li>
    );
};

RouteOption.propTypes = {
    type: PropTypes.oneOf(Object.values(ROUTE_OPTIONS)).isRequired,
    selectRouteOption: PropTypes.func.isRequired,
    selectedRouteOption: PropTypes.oneOf(Object.values(ROUTE_OPTIONS)).isRequired,
    travelTimeMins: PropTypes.number,
    Icon: PropTypes.elementType.isRequired,
    isNightSafeActive: PropTypes.bool,
    primaryColors: PropTypes.object,
};

export default RouteOption;
